<template>
    <div class="video flex flex-column">
        <dark-header></dark-header>
        <div class="flex flex-between player-container">
            <player v-if="!loading" class="flex-item player" :video="video"></player>
        </div>
    </div>
</template>

<script>
import DarkHeader from '@components/DarkHeader.vue';
import Player from '@components/live/Player.vue';
import { getLiveVideoDetail } from '@api/liveList';

export default {
    components: { DarkHeader, Player },
    data() {
        return {
            video: {},
            loading: true
        };
    },
    created() {
        this.init();
    },
    beforeDestroy() {
        this.$trackEvent('直播', '退出直播', this.$route.query.id);
    },
    methods: {
        async init() {
            await this.getVideoDetail();
        },
        async getVideoDetail() {
            this.loading = true;
            try {
                const { data } = await getLiveVideoDetail(this.$route.query.id);
                this.video = data;
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.video {
    width: 100%;
    height: 100vh;
    position: relative;
}
</style>
